import { useState } from "react";
import useSound from "use-sound";
import { MdSkipNext } from "react-icons/md";
import musicFile from "../songs/H.O.B.A. - Release.mp3";
import musicFile2 from "../songs/callLeap.mp3";
import musicFile3 from "../songs/remember_me.mp3";
import vinylImg from "../assets/img/vinyl.png";

const songs = [musicFile, musicFile2, musicFile3];

export function BackgroundMusic() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const [play1, controls1] = useSound(songs[0], { volume: 0.8, onend: () => next() });
  const [play2, controls2] = useSound(songs[1], { volume: 0.8, onend: () => next() });
  const [play3, controls3] = useSound(songs[2], { volume: 0.8, onend: () => next() });

  const players = [
    { play: play1, ...controls1 },
    { play: play2, ...controls2 },
    { play: play3, ...controls3 }
  ];

  function toggle() {
    const player = players[currentIndex];
    if (isPlaying) player.pause();
    else player.play();
    setIsPlaying(!isPlaying);
  }

  function next() {
    players[currentIndex].stop();
    const newIndex = (currentIndex + 1) % songs.length;
    setCurrentIndex(newIndex);
    setTimeout(() => {
      players[newIndex].play();
      setIsPlaying(true);
    }, 120);
  }

  const vinylStyle = {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundImage: `url(${vinylImg})`,
    backgroundSize: "cover",
    cursor: "pointer",
    animation: isPlaying ? "spin 3s linear infinite" : "none",
  };

  const nextIconStyle = {
    cursor: "pointer",
    fontSize: "30px",
    color: "#333",
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
      <div style={vinylStyle} onClick={toggle}></div>
      <MdSkipNext style={nextIconStyle} onClick={next} />

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
